module.exports = __webpack_public_path__ + "static/media/edit_pencil.93bc03bc.svg";